import { render, staticRenderFns } from "./NftRelation.vue?vue&type=template&id=1f0a5cfe&scoped=true&lang=pug"
import script from "./NftRelation.vue?vue&type=script&lang=js"
export * from "./NftRelation.vue?vue&type=script&lang=js"
import style0 from "./NftRelation.vue?vue&type=style&index=0&id=1f0a5cfe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0a5cfe",
  null
  
)

export default component.exports